import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import SET_SHARED_ENV from './types';
export default _defineProperty({}, SET_SHARED_ENV, function (state, payload) {
  var currentState = state;
  currentState.payload = payload;
});